import { ApexOptions } from "apexcharts";
import Chart from "react-apexcharts";

interface BubbleChartInterface {
  series: any;
  categories: any;
  colors?: string[];
  yAxisTitle?: string;
  xAxisTitle?: string;
}

const BubbleChart: React.FC<BubbleChartInterface> = (props) => {
  const { series, yAxisTitle, xAxisTitle, colors } = props;

  const options: ApexOptions = {
    colors: colors,
    chart: {
      type: "bubble",
      toolbar: {
        show: false,
      },
    },
    dataLabels: {
      enabled: false,
    },
    xaxis: {
      labels: {
        style: {
          colors: "white",
          fontSize: "12px",
        },
      },
      title: {
        text: yAxisTitle,
        style: {
          fontSize: "16px",
          color: "white",
        },
      },
      tickAmount: 10,
      type: "category",
      min: 0,
      max: 50,
    },
    yaxis: {
      min: 0,
      max: 100,
      title: {
        text: xAxisTitle,
        style: {
          fontSize: "16px",
          color: "white",
        },
      },
      labels: {
        style: {
          colors: "white",
        },
        formatter: (val) => (val || 0).toPrecision(3),
      },
    },
    legend: {
      show: false,
      fontSize: "16px",
      labels: {
        colors: "white",
      },
    },
    annotations: {
      xaxis: [
        { x: 25, borderWidth: 4, strokeDashArray: 0, borderColor: "#fff" },
      ],
      yaxis: [
        { y: 50, borderWidth: 4, strokeDashArray: 0, borderColor: "#fff" },
      ],
    },
  };

  return (
    <div>
      <Chart options={options} series={series} type="bubble" />
    </div>
  );
};

export default BubbleChart;
